import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Http from "../../Http";
import { Loan_API } from "../../Helper";

import { motion } from "framer-motion";
import {
  FaCalendarAlt,
  FaFileInvoiceDollar,
  FaExclamationTriangle,
  FaUniversity,
  FaBalanceScale,
  FaBook,
  FaTractor,
  FaExchangeAlt,
  FaLock,
  FaMoneyBillWave,
  FaMoneyCheckAlt,
  FaWallet,
  FaShieldAlt,
  FaUserFriends,
  FaCreditCard,
  FaBookOpen,
  FaClock,
  FaMotorcycle,
  FaRedo,
  FaBolt,
  FaPercentage,
  FaBuilding 
} from "react-icons/fa";
import { GiGoldBar } from "react-icons/gi";
import { FaUser, FaStar } from "react-icons/fa";
import {
  FaBirthdayCake,
  FaBriefcase,
  FaUserCheck,
  FaChartLine,
  FaHome,
  FaIdCard,
  FaUnlock,
  FaRupeeSign,
  FaPercent,
  FaRocket,
  FaBusinessTime,
  FaFileAlt,
  FaUserClock
} from "react-icons/fa";
import {
  FaLandmark,         
     
  FaTools,            

} from "react-icons/fa";
import { ArrowRight } from "lucide-react";
import AdBanner from "../AdPage/AdBanner";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const BusinessLoanNew = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loanData, setLoanData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const faqs = [
    {
      question: "What is a business loan and who can apply for it?",
      answer:
        " A business loan is an unsecured or secured loan provided to entrepreneurs, startups, SMEs, or large enterprises to support business operations, expansion, or working capital needs. Eligible applicants include self-employed professionals, sole proprietors, partnerships, private limited companies, and LLPs with stable income and operational history (usually at least 1 year).",
    },
    {
      question:
        " How much loan amount can I get for my business?",
      answer:
        "Loan amounts typically range from ₹50,000 to ₹2 crore for unsecured loans, depending on the lender and business profile. Secured loans (backed by collateral) can go even higher. The amount sanctioned depends on your business turnover, credit score, cash flow, and years in operation.",
    },
    {
      question:
        " What is the interest rate for business loans in India?",
      answer:
        " Business loan interest rates in India generally range from 9% to 24% per annum, depending on the lender, loan type (secured/unsecured), and applicant’s creditworthiness. Public sector banks like SBI offer lower rates for MSMEs under government schemes, such as CGTMSE or Mudra Yojana.",
    },
    {
      question: "What are the documents required to apply for a business loan?",
      answer:
        "  While documentation may vary by lender, typically required documents include: 1. PAN & Aadhaar of owner 2. Business registration proof 3. Bank statements (last 6–12 months) 3. ITR for last 1–2 years 4. GST returns 5. Profit & Loss statement and Balance Sheet",
    },
    {
      question:
        "Can I get a business loan through TheFinMaster.com?",
      answer:
        "  TheFinMaster.com does not directly issue business loans. Instead, we provide educational resources, comparison tools, and independent information to help you evaluate various business loan options from trusted banks and NBFCs. After choosing the right loan offer, you’ll be guided to the respective lender’s official portal to complete your secure application.",
    },

    {
      question: "What types of business loans are available?",
      answer: "Business loans can be classified into various types, including working capital loans, term loans, equipment loans, and trade finance. The type of loan you choose will depend on your business needs—whether you require funds for daily operations, expansion, or purchasing equipment."
    },
    {
      question: "What is the eligibility criteria for a business loan?",
      answer: "Eligibility for a business loan varies by lender, but common requirements include having a minimum turnover (typically ₹10 lakh), a stable business for at least 1-2 years, a good credit score (above 650), and proper documentation like business financials and tax returns."
    },
    {
      question: "How long does it take to get approval for a business loan?",
      answer: "The approval time for a business loan can vary from a few days to several weeks, depending on the lender and the type of loan. Online lenders often offer faster approval times, while traditional banks may take longer to process and approve loans."
    },
    {
      question: "Can I get a business loan with no collateral?",
      answer: "Yes, some financial institutions offer unsecured business loans that do not require collateral. These loans are typically available to businesses with a strong credit history, good cash flow, and a proven track record of profitability."
    },
    {
      question: "What is the loan repayment tenure for business loans?",
      answer: "Business loan tenures typically range from 1 year to 5 years, depending on the lender and loan type. Longer tenures result in lower EMIs, while shorter tenures allow you to pay off the loan faster but with higher EMIs."
    },
    {
      question: "Can I use a business loan for personal expenses?",
      answer: "No, business loans must be used for business-related purposes only, such as expanding operations, purchasing inventory, or improving infrastructure. Using business loan funds for personal expenses may result in penalties or loan rejection."
    },
    {
      question: "Do I need to provide a business plan to apply for a loan?",
      answer: "Yes, in many cases, especially for large loans, lenders may ask for a business plan that outlines your business model, financial projections, market strategy, and repayment plan. This helps the lender assess your ability to repay the loan."
    },
    {
      question: "What are the advantages of a secured business loan?",
      answer: "A secured business loan offers lower interest rates and higher loan amounts because it’s backed by collateral. This reduces the risk for lenders and, in return, provides borrowers with better loan terms."
    },
    {
      question: "What is the difference between a working capital loan and a term loan?",
      answer: "A working capital loan is used for daily business expenses like payroll, utilities, or inventory, while a term loan is for longer-term investments, such as purchasing equipment or expanding your business. Working capital loans are typically short-term, while term loans have longer repayment periods."
    },
    {
      question: "Can I get a business loan if my business has a low credit score?",
      answer: "While a low credit score can make it more challenging to secure a loan, it’s not impossible. Some lenders offer loans with higher interest rates or require collateral. Alternatively, you may explore government schemes or loans for MSMEs, which may have more relaxed credit score requirements."
    },
    {
      question: "What is a loan agreement, and what should I look for in it?",
      answer: "A loan agreement outlines the terms and conditions of the loan, including interest rates, repayment schedules, and collateral details. When reviewing a loan agreement, ensure that the terms align with your business needs and that you understand any penalties for late payments or prepayment."
    },
    {
      question: "Can I apply for a business loan if I am a start-up?",
      answer: "Yes, start-ups can also apply for business loans, though the eligibility criteria may differ. Some lenders may require a solid business plan, proof of concept, or potential for growth. There are also government schemes designed specifically for start-up funding."
    },
    {
      question: "Are business loans taxable?",
      answer: "No, the loan amount you receive is not taxable as income, but the interest paid on the loan is considered an expense and can be deducted from your taxable income. Always consult a tax advisor to ensure proper compliance with tax laws related to business loans."
    }
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    fetchLoanData();
  }, []);
  const fetchLoanData = async () => {
    try {
      const response = await Http.get(Loan_API);

      // The response structure might have nested data
      // Check if response has an insurance property (like in the original fetch response)
      const data = response.loan || response;

      // Filter the insurance data to show only Car category
      const carLoanData = Array.isArray(data)
        ? data.filter((insurance) => insurance.category_name === "Business Loan")
        : [];

      setLoanData(carLoanData);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch Loan data");
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };
  const loanTypes = [
    {
      name: "Term Loans  🏦",
      description:
        "A term loan is a standard business loan where a lump sum amount is borrowed and repaid over a fixed tenure in EMIs. These loans can be short-term (up to 3 years) or long-term (up to 10 years) and are used for business expansion, purchasing assets, or funding major investments.",
      icon: <FaLandmark />,
    },
    {
      name: "Working Capital Loans 💼",
      description:
        " This loan is designed to manage a business’s daily operational expenses, including salaries, rent, and inventory purchases. Working capital loans are typically short-term and help businesses maintain liquidity during cash flow fluctuations.",
      icon: <FaMoneyBillWave/>,
    },
    {
      name: "Equipment or Machinery Loans 🛠️",
      description:
        "These loans are used to purchase new machinery, tools, or equipment required for business operations. The purchased equipment often acts as collateral for the loan, reducing the risk for lenders.",
      icon: <FaTools />,
    },
    {
      name: "Invoice Financing (Bill Discounting) 📄",
      description:
        "Invoice financing allows businesses to access immediate funds against pending invoices. Lenders provide a percentage of the invoice value upfront, ensuring businesses do not face liquidity crunches while waiting for client payments.",
      icon: <FaFileInvoiceDollar />,
    },

    {
      name: "Business Credit Line (Overdraft Facility)  🔁",
      description:
        "A credit line provides businesses with access to funds as needed, up to a predefined limit. Interest is charged only on the amount utilized, making it a flexible option for managing short-term financial needs.",
      icon: <FaExchangeAlt />,
    },
    {
      name: "Government Business Loans (MSME Loans)  🏛️",
      description:
        "Various government schemes, such as MUDRA Loans, Stand-Up India, and CGTMSE, provide financial support to small and medium businesses with lower interest rates and relaxed eligibility criteria.",
      icon: <FaUniversity />,
    },
  ];

  const benefitshealth = [
    {
      title: "New Two-Wheeler Loan",
      description:
        "A standard loan provided to individuals looking to purchase a brand-new bike or scooter. Lenders typically finance up to 90-100% of the on-road price, depending on the borrower's profile and lender policies.",
      icon: <FaMotorcycle className="text-4xl text-blue-600" />,
    },

    {
      title: "Used Two-Wheeler Loan",
      description:
        " Designed for purchasing pre-owned bikes or scooters, these loans generally have a lower loan-to-value (LTV) ratio, covering up to 75-80% of the bike’s valuation. Interest rates may be slightly higher due to the depreciated value of used vehicles.",
      icon: <FaRedo className="text-4xl text-green-600" />,
    },
    {
      title: "Electric Two-Wheeler Loan",
      description:
        " With the growing focus on sustainable transportation, many lenders offer loans specifically for electric two-wheelers. These loans may come with lower interest rates, government subsidies, or incentives to encourage eco-friendly vehicle adoption.",
      icon: <FaBolt className="text-4xl text-purple-600" />,
    },

    {
      title: "Two-Wheeler Loan for Bad Credit Holders",
      description:
        " Special financing options for individuals with low or no credit scores. These loans may require a higher interest rate, additional guarantors, or collateral security.",
      icon: <FaExclamationTriangle className="text-4xl text-red-600" />,
    },
    {
      title: "Two-Wheeler Loan with No Down Payment",
      description:
        " Some banks and NBFCs offer zero down payment loans, where 100% of the bike's cost is financed, reducing the need for an upfront payment. However, such loans may come with higher interest rates or stricter eligibility criteria.",
      icon: <FaCreditCard className="text-4xl text-orange-600" />,
    },
  ];

  const points = [
    {
      description: ` Lower interest rates than personal loans for business needs. `,
    },
    {
      description: ` Helps in cash flow management and business expansion.`,
    },
    {
      description: `  Flexible repayment terms available.`,
    },
    {
      description: `Tax benefits under Section 37(1) of the Income Tax Act.`,
    },
  ];
  const points1 = [
    {
      description: `Requires financial documentation and good credit history.`,
    },
    {
      description: ` Secured loans require collateral, adding risk. `,
    },
    {
      description: `Processing time may be longer for higher loan amounts.`,
    },
    // {
    //   title: "Depreciation Impact ",
    //   description: ` The bike's value depreciates over time, reducing resale value while the loan is still being repaid.`,
    // },
  ];

  const points3 = [
    {
      title: " Business Needs & Loan Type",
      points: [
        " Determine whether you need a term loan, working capital loan, or equipment financing based on business expansion, operational funding, or asset acquisition.",
      ],
    },
    {
      title: "Interest Rates & Charges ",
      points: [
        "  Compare lenders to find the best interest rate and lowest processing fees to reduce borrowing costs.",
      ],
    },
    {
      title: "Loan Amount & Tenure",
      points: [
        "Choose an amount that covers your financial requirements without overburdening repayment. A longer tenure reduces EMI stress but increases interest costs.",
      ],
    },
    {
      title: "Collateral vs. Unsecured Loans",
      points: [
        " Decide if you’re willing to pledge assets for lower rates or opt for unsecured loans for faster approval.",
      ],
    },
    {
      title: "Lender’s Reputation & Customer Service",
      points: [
        "Select a bank or NBFC with transparent policies, good customer support, and seamless loan processing.",
      ],
    },
    {
      title: " Government Schemes & Subsidies",
      points: [
        " Check eligibility for MUDRA Loans, Stand-Up India, or other subsidized loan options to reduce financing costs.",
      ],
    },

  ];

  const eligibilityCriteria = [
    {
      title: "Collateral Requirement",
      points: [
        " Some business loans require collateral, such as property, inventory, or receivables, while others are unsecured. Secured loans generally come with lower interest rates and higher borrowing limits.",
       
      ],
      icon: <FaLock className="text-purple-500 text-2xl" />,
    },
    {
      title: "Disbursal Time",
      points: [
        " Business loans are generally disbursed within a few days, with some digital lenders offering same-day approvals. The processing time depends on documentation, credit assessment, and loan type.",
       
      ],
      icon: <FaRocket className="text-purple-500 text-2xl" />,
    },
    {
      title: "Loan Amount (Principal)",
      points: [
        "The principal amount is the total sum borrowed by the business. The loan amount is determined based on factors such as business revenue, credit score, financial history, and purpose of the loan. Lenders evaluate the borrowing capacity before approving the required funds.",
      ],
      icon: <FaMoneyCheckAlt className="text-orange-500 text-2xl" />,
    },
    {
      title: "Interest Rate",
      points: [
        "Business loan interest rates can be fixed or floating and vary based on the borrower’s creditworthiness, loan type, and lender policies. Generally, secured loans have lower interest rates, while unsecured business loans have higher rates due to the increased risk for lenders.",
      ],
      icon: <FaPercentage className="text-orange-500 text-2xl" />,
    },
    {
      title: "Loan Tenure",
      points: [
        "The tenure of a business loan depends on the type and purpose of the loan. Short-term loans have a tenure of 1-3 years, whereas long-term loans can extend up to 10-15 years. A longer tenure reduces the monthly EMI burden but increases the total interest paid.",
       
      ],
      icon: <FaClock className="text-blue-500 text-2xl" />,
    },
    {
      title: "Repayment Structure",
      points: [
        "Business loans can have different repayment structures, such as fixed monthly EMIs, flexible repayment schedules, or bullet payments. Some lenders offer moratorium periods, where businesses start repayment after a specific duration.",
        
      ],
      icon: <FaCalendarAlt className="text-orange-500 text-2xl" />,
    },

   
    {
      title: "Processing Fees & Additional Charges",
      points: [
        "Lenders charge processing fees (typically 1-3% of the loan amount) along with other costs like documentation charges, foreclosure fees, and late payment penalties. Borrowers should evaluate these additional costs before choosing a lender.",
       
      ],
      icon: <FaFileInvoiceDollar className="text-purple-500 text-2xl" />,
    },
  
  ];
  const componentsData1 = [
    {
      title: "Age Criteria 🧓",
      icon: <FaUserClock  className="text-2xl text-blue-600" />,
      points: [
        "The applicant must be between 21 to 65 years.",
      ],
    },

   
    {
      title: "Minimum Annual Turnover 💹",
      icon: <FaRupeeSign className="text-2xl text-red-600" />,
      points: [
        "The required turnover varies but generally starts from ₹10 lakh per annum.",
      ],
    },
    {
      title: "Credit Score ⭐",
      icon: <FaStar className="text-2xl text-red-600" />,
      points: [
        " A credit score of 750+ improves approval chances and secures better interest rates.",
      ],
    },
    {
      title: "Profitability & Cash Flow 💵",
      icon: <FaMoneyBillWave className="text-2xl text-green-600" />,
      points: [
        " Lenders assess profitability and cash flow stability before approving loans.",
       
      ],
    },
    {
      title: " Documents Required 📄",
      icon: <FaFileAlt  className="text-2xl text-yellow-600" />,
      points: [
        "Includes business registration proof, financial statements, tax returns, and KYC documents.",

      ],
    },
    {
      title: "Business Vintage 🏢",
      icon: <FaBusinessTime className="text-2xl text-purple-600" />,
      points: [
        "Lenders prefer businesses operating for at least 2-3 years with consistent revenue.",
      ],
    },

    
  ];
  const comparisonData2 = [
    {
      feature: "Purpose",
      icon: <FaBook className="w-4 h-4 inline-block text-blue-500 mr-1" />,
      educationLoan:
        "Specifically for educational expenses (tuition, books, living costs, etc.)",
      personalLoan: "Can be used for any purpose, including education",
    },
    {
      feature: "Interest Rate",
      icon: (
        <FaPercentage className="w-4 h-4 inline-block text-green-500 mr-1" />
      ),
      educationLoan: "Lower interest rates (typically 8-12%)",
      personalLoan: "Higher interest rates (10-24%)",
    },
    {
      feature: "Loan Amount",
      icon: (
        <FaMoneyBillWave className="w-4 h-4 inline-block text-purple-500 mr-1" />
      ),
      educationLoan:
        "Higher amounts offered, covering up to 100% of tuition fees",
      personalLoan: "Limited based on the borrower's creditworthiness",
    },
    {
      feature: "Repayment Start",
      icon: <FaClock className="w-4 h-4 inline-block text-yellow-500 mr-1" />,
      educationLoan:
        "Repayment starts after course completion + moratorium period",
      personalLoan: "Repayment starts immediately after loan disbursal",
    },
    {
      feature: "Collateral Requirement",
      icon: <FaLock className="w-4 h-4 inline-block text-pink-500 mr-1" />,
      educationLoan: "Required for higher loan amounts (above ₹7.5 lakh)",
      personalLoan:
        "Generally unsecured, but higher loan amounts may need collateral",
    },
    {
      feature: "Tax Benefits",
      icon: (
        <FaFileInvoiceDollar className="w-4 h-4 inline-block text-rose-500 mr-1" />
      ),
      educationLoan:
        "Interest payments qualify for tax deductions under Section 80E of the IT Act",
      personalLoan: "No tax benefits",
    },
    {
      feature: "Co-Applicant Requirement",
      icon: (
        <FaUserFriends className="w-4 h-4 inline-block text-indigo-500 mr-1" />
      ),
      educationLoan: "Mandatory co-applicant (parent/guardian/spouse)",
      personalLoan:
        "Not required unless borrower has low income or poor credit history",
    },
  ];
  const features = [
    { icon: '🏢', text: ' Real-Time EMI & Repayment View' },
    { icon: '⏱️', text: 'Takes Less Than a Minute' },
    { icon: '📊', text: ' Supports Custom Loan Amounts' },
    { icon: '📲', text: 'Works on All Devices Instantly' },
    { icon: '📄', text: 'No Financial Inputs Needed' },
    { icon: '📈', text: ' Helps Plan Business Cash Flow' },
  ];
  return (
    <>
      <Helmet>
        <title>
         Business Loans in India – Apply Online, Check Eligibility & Benefits
        </title>
        <meta
          name="description"
          content="Get the right business loan to grow your venture. Compare loan options, check eligibility, know interest rates, and apply online with ease for quick approval."
        />
        <meta
          name="keywords"
          content="motor bike loan, two wheeler loan interest rate, second hand bike loan, 0 interest two wheeler loan, bike loan apply online"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/business-loan"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">
              Home
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>
          <li className="flex items-center">
            <span className="text-gray-500 ">Business Loan</span>
          </li>
        </ol>
      </nav>
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex justify-center">
          <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
            <div className="w-full sm:w-[50%]">
              <div className="w-[90%]">
                <h1 className="text-3xl md:text-4xl font-bold mt-6 md:mt-0 md:pl-0 pl-6">
                  <span className="text-blue-600 ">
                  Fuel your business dreams with easy Business Loans
                  </span>{" "}
                  quick approval, minimal paperwork, and tailored plans for every entrepreneur
                </h1>
                {/* <a href="#insurance_plans">
                  <button className="py-4 px-8  border rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl text-lg mt-10 font-medium">
                    See Plans
                  </button>
                </a> */}
              </div>
            </div>
            <div className="w-full sm:w-[50%]">
              <img
                className="w-full max-w-full mt-2"
                src="/assets/bu.png"
                alt="Two Wheeler-loan"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
        <p className="text-lg md:text-base lg:text-lg text-center">
        At TheFinMaster.com, we understand the power of ideas—and the capital needed to bring them to life. Our platform simplifies your business loan journey by connecting you with top lenders offering competitive rates, flexible tenures, and funding suited to your goals. Whether it's for expansion, inventory, equipment, or working capital, TheFinMaster.com helps you find the perfect business loan to turn your vision into reality.{" "}
        </p>
      </div>
      <div className="container mx-auto">
      <div className="flex flex-col lg:flex-row">
      <div className="w-full lg:w-3/4">
      <div id="loan_plans" className="lg:pr-6 md:px-4 px-2">
      {loading ? (
              <div className="text-center py-10">Loading Loan options...</div>
            ) : error ? (
              <div className="text-center py-10 text-red-600">{error}</div>
            ) : loanData.length === 0 ? (
              <div className="text-center py-10">
                No Business Loan options available at the moment.
              </div>
            ) : (
          loanData.map((loan) => (
            <div
              key={loan.id}
              className="md:w-full max-w-[900px] py-2 border shadow-lg overflow-hidden hover:shadow-xl rounded-lg flex flex-wrap md:flex-nowrap gap-5 justify-between mx-auto mt-4"
            >
              <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center md:justify-normal">
                <Link to={`/business-loan/${loan.page_url}`}>
                  <div className="w-[95%] md:w-[220px] overflow-hidden py-2 md:ml-2">
                    <img
                      className="w-full h-full object-contain"
                      alt={loan.page_title || "Loan Provider"}
                      src={loan.image}
                    />
                  </div>
                </Link>
              </div>

              <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                <p className="text-gray-500 font-medium">Interest Rate</p>
                <h4 className="text-2xl py-0.5 font-bold">
                  {loan.interest_rate}%
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                <p className="text-gray-500 font-medium">Loan Amount </p>
                <h4 className="text-2xl py-0.5 font-bold">
                  ₹{loan.loan_amount}
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-0 mt-0 md:mt-10 text-center">
                <p className="text-gray-500 font-medium">Processing Fee</p>
                <h4 className="text-2xl py-0.5 font-bold">
                  {loan.processing_fee}
                </h4>
              </div>

              <div className="flex flex-wrap justify-center md:justify-between items-center my-5 w-full gap-2 px-4">
                <a
                  href={loan.bank_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-green-500 text-white font-semibold py-2 px-4 rounded hover:bg-green-600 transition duration-300">
                    Apply Now
                  </button>
                </a>

                <Link to={`/business-loan/${loan.page_url}`}>
                  <button className="text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500">
                  See Details
                  </button>
                </Link>
              </div>
            </div>
          ))
        )}
            </div>
</div>
<div className="w-full lg:w-1/4 px-2 md:px-4 mt-6 lg:mt-0">
          <div className="sticky top-20">
            {/* Ad 1 - Visible on all screen sizes */}
            <AdBanner displayOrder="2" />
            
            {/* Ad 2 - Hidden on small mobile, visible on larger screens */}
            {/* <a href="https://example.com/premium-discount" target="_blank" rel="noopener noreferrer" className="hidden sm:block mt-6">
              <img 
                src="/assets/niyoo.png" 
                alt="Premium Discount Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
            
            {/* Compact ad for mobile only */}
            {/* <a href="https://example.com/mobile-offer" target="_blank" rel="noopener noreferrer" className="block sm:hidden mt-4">
              <img 
                src="/assets/niyoo.png" 
                alt="Mobile Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
          </div>
        </div>
      </div>
    </div>

      <div className="flex justify-center items-center  p-4 mt-10">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            What is a Business Loan?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            A business loan is a financial instrument that allows entrepreneurs,
            startups, and established businesses to access funds for various
            operational needs. These loans can be used for expanding business
            operations, purchasing inventory, managing working capital,
            upgrading equipment, or investing in new projects. Business loans
            can be secured (requiring collateral) or unsecured (based on the
            borrower’s creditworthiness and financial standing).
          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
          Financial institutions, including banks, non-banking financial companies (NBFCs), and online lenders, offer business loans with varying interest rates, loan tenures, and repayment terms. The eligibility for a business loan depends on factors such as the company’s financial performance, credit score, annual turnover, and business stability.
          </p>
        </div>
      </div>
      <section className="bg-blue-50 py-6 px-4 sm:px-6 md:px-20 lg:px-20 rounded-3xl shadow-lg max-w-6xl mx-auto mt-6"> 
  <div className="flex flex-col md:flex-row justify-between items-center gap-10">
    {/* Left - Text and CTA */}
    <div className="max-w-xl space-y-6 text-center md:text-left">
      <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 leading-tight">
        Calculate Your Business Loan <br />
        in <span className="text-blue-600">Seconds</span>
      </h2>
      <p className="text-gray-700 text-lg">
        Use our fast and free calculator to estimate your premium — no paperwork, no waiting.
      </p>
      <Link
        to="/financial-tools-calculators/business-loan-emi-calculator"
        className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 text-lg rounded-full shadow-md transition"
      >
        Start Calculating <ArrowRight className="w-5 h-5" />
      </Link>
    </div>

    {/* Right - Feature List with Emojis */}
    <div className="space-y-4 text-left">
      {features.map((item, index) => (
        <div key={index} className="flex items-center gap-3">
          <span className="text-xl">{item.icon}</span>
          <span className="text-gray-800 font-medium">{item.text}</span>
        </div>
      ))}
    </div>
  </div>
</section>
      <div className="max-w-6xl mx-auto px-4 py-6 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
        Key Stats of Business Loans in India
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2">
          Choosing the right car insurance is crucial for financial security on
          the road. Here are the three main types of car insurance plans:
        </p> */}

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">📊</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
            Growing MSME Loan Disbursements
            </h3>
            <p className="text-gray-700 text-sm mt-1">
            In FY 2023, India’s Micro, Small, and Medium Enterprises (MSME) sector saw a 25% increase in credit disbursements, with banks and NBFCs providing over ₹22 trillion in business loans.
            </p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">💻</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
            Rising Digital Lending Adoption
            </h3>
            <p className="text-gray-700 text-sm mt-1">
            Digital lending platforms accounted for 20% of total business loan disbursements, driven by the ease of online application processes and quick approvals.

            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">📉</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
            Average Business Loan Interest Rates
            </h3>
            <p className="text-gray-700 text-sm mt-1">
            The interest rates on business loans in India range from 8% to 24%, depending on the lender, borrower’s credit profile, and loan type.

            </p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🏛️</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
            Government Initiatives
            </h3>
            <p className="text-gray-700 text-sm mt-1">
            Schemes like MUDRA Loans and CGTMSE (Credit Guarantee Fund Trust for Micro and Small Enterprises) have significantly improved credit accessibility for small businesses.

            </p>
          </div>
        </div>
      </div>


    <div className="max-w-6xl mx-auto px-6 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center">
        Types of Business Loans
        </h2>
        <p className="text-gray-700 text-base md:text-lg mt-3 text-center max-w-3xl mx-auto">
        Business loans are available in multiple forms to cater to different financial needs and business models. Below are the major types:

        </p>

        {/* Responsive Grid Layout */}
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {loanTypes.map((loan, index) => (
            <motion.div
              key={index}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
              className="bg-white shadow-md border border-gray-200 rounded-xl p-6 flex flex-col"
            >
              <div className="text-3xl text-blue-500">{loan.icon}</div>
              <h3 className="text-xl font-semibold mt-3">{loan.name}</h3>
              <p className="mt-2 text-gray-600">{loan.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center  mb-6">
        Key Components of a Business Loan
        </h2>
        {/* <p className="text-gray-600 text-center mb-8">
        Business loans are available in multiple forms to cater to different financial needs and business models. Below are the major types:
        </p> */}

        {/* <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {eligibilityCriteria.map((criteria, index) => (
            <div
              key={index}
              className="p-6 bg-gray-100 shadow-md rounded-2xl hover:shadow-lg transition-all duration-300p-6 bg-gray-100 shadow-md rounded-2xl hover:shadow-lg transition-all duration-300"
            >
              {criteria.icon}
              <div>
                <h3 className="font-semibold text-lg mb-2">{criteria.title}</h3>
                <ul className="list-disc list-inside text-gray-600 text-md">
                  {criteria.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <div className="grid md:grid-cols-2 gap-8">
          {eligibilityCriteria.map((criteria, index) => (
            <div
              key={index}
              className="p-6 bg-gray-100 shadow-md rounded-2xl hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start gap-4 mb-3">
                {criteria.icon}
                <h3 className="text-lg font-semibold">{criteria.title}</h3>
              </div>
              <ul className="list-disc list-inside text-gray-700 space-y-1 text-md">
                {criteria.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 py-6">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">
        Eligibility Criteria to Avail a Business Loan
        </h2>
        {/* <p className="text-center text-gray-600 mb-10">
        To avail of a two-wheeler loan, applicants must meet certain eligibility criteria set by financial institutions. The requirements may vary slightly among lenders, but the general criteria are as follows:

        </p> */}

        <div className="grid md:grid-cols-2 gap-8">
          {componentsData1.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md p-5 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start gap-4 mb-3">
                {item.icon}
                <h3 className="text-lg font-semibold">{item.title}</h3>
              </div>
              <ul className="list-disc list-inside text-gray-700 space-y-1 text-md">
                {item.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>

      <section className="max-w-7xl mx-auto px-4 py-6">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white flex items-center gap-2 mb-4 ml-4">
        <FaBuilding className="text-blue-600" />
        Why Business Loan?
      </h2>

      <p className="text-gray-700 dark:text-gray-300 mb-4 leading-relaxed ml-4">
        A business loan is an essential financial tool for entrepreneurs looking to expand, sustain, or innovate within their industry. Unlike other types of loans, business loans are designed specifically for commercial use, allowing businesses to optimize operations and drive growth. By providing immediate capital, business loans help in:
      </p>

      <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-1 mb-6 ml-4">
        <li>Expanding production capacity and reaching new markets</li>
        <li>Managing cash flow effectively during seasonal demand fluctuations</li>
        <li>Upgrading to modern equipment and technology</li>
        <li>Covering short-term operational costs without disrupting revenue generation</li>
      </ul>

      <h3 className="text-xl font-semibold text-gray-800 dark:text-white mb-4 ml-4">
        Comparison with Other Financing Options:
      </h3>

      <div className="w-full  lg:ml-4 md:ml-4 sm:ml-0 ml-0">
  <div className="hidden md:block">
    {/* Normal Table for medium+ screens */}
    <table className="w-full border border-gray-300 text-sm text-left">
      <thead className="bg-gray-100">
        <tr>
          <th className="p-3 border">Feature</th>
          <th className="p-3 border">Business Loan</th>
          <th className="p-3 border">Personal Loan</th>
          <th className="p-3 border">Loan Against Property</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="p-3 border">Purpose</td>
          <td className="p-3 border">Business Growth</td>
          <td className="p-3 border">Any personal expense</td>
          <td className="p-3 border">Fundraising using property</td>
        </tr>
        <tr>
          <td className="p-3 border">Collateral Required</td>
          <td className="p-3 border">Optional</td>
          <td className="p-3 border">No</td>
          <td className="p-3 border">Yes</td>
        </tr>
        <tr>
          <td className="p-3 border">Interest Rate</td>
          <td className="p-3 border">8-24%</td>
          <td className="p-3 border">10-24%</td>
          <td className="p-3 border">9-15%</td>
        </tr>
        <tr>
          <td className="p-3 border">Loan Tenure</td>
          <td className="p-3 border">Up to 10 years</td>
          <td className="p-3 border">1-5 years</td>
          <td className="p-3 border">10-20 years</td>
        </tr>
        <tr>
          <td className="p-3 border">Tax Benefits</td>
          <td className="p-3 border">Yes</td>
          <td className="p-3 border">No</td>
          <td className="p-3 border">Limited tax benefits</td>
        </tr>
      </tbody>
    </table>
  </div>

  {/* Stacked view for small screens */}
  <div className="block md:hidden space-y-6">
    {/* Repeat for each row */}
    {[
      {
        label: "Purpose",
        business: "Business Growth",
        personal: "Any personal expense",
        property: "Fundraising using property"
      },
      {
        label: "Collateral Required",
        business: "Optional",
        personal: "No",
        property: "Yes"
      },
      {
        label: "Interest Rate",
        business: "8-24%",
        personal: "10-24%",
        property: "9-15%"
      },
      {
        label: "Loan Tenure",
        business: "Up to 10 years",
        personal: "1-5 years",
        property: "10-20 years"
      },
      {
        label: "Tax Benefits",
        business: "Yes",
        personal: "No",
        property: "Limited tax benefits"
      },
    ].map((item, index) => (
      <div
        key={index}
        className="border rounded-lg p-4 bg-white dark:bg-gray-800 shadow-sm"
      >
        <h4 className="font-semibold text-gray-800 dark:text-white mb-2">
          {item.label}
        </h4>
        <p><span className="font-medium">Business Loan:</span> {item.business}</p>
        <p><span className="font-medium">Personal Loan:</span> {item.personal}</p>
        <p><span className="font-medium">Loan Against Property:</span> {item.property}</p>
      </div>
    ))}
  </div>
</div>
    </section>

      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 ">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
          Pros and Cons of Business Loans
          </h2>
          <p className="text-gray-700 mb-6">✅ Pros:</p>

          {points.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 ">
          <h3 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            Cons of a Business Loans
          </h3>
          <p className="text-gray-700 mb-6">❌ Cons</p>

          {points1.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className=" px-2 p-6 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h2 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
          Choosing the Right Business Loan
          </h2>
          {/* <p className="text-gray-700 mb-6">
            Choosing the right gold loan is crucial to ensuring that you get the
            best deal with minimal financial burden. A gold loan can be a
            convenient way to meet short-term financial needs, but selecting the
            right lender and loan terms is essential for a hassle-free borrowing
            experience. Here are the key factors to consider when choosing a
            gold loan:
          </p> */}

          {points3.map((item, index) => (
            <div
              key={index}
              className="p-5 mb-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {item.title}
              </h2>
              <ul className="list-disc list-inside text-gray-600 mt-2">
                {item.points.map((point, idx) => (
                  <li key={idx} className="mt-1">
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      {/* FAQ section */}
      <div className="max-w-4xl mx-auto py-6 p-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BusinessLoanNew;
